<template>
  <div class="popup-package">
    <div class="dialog_box" v-if="type==1">
      <div class="dialog_message">手机浏览器暂不支持查看该课件<br/>你可在"中公教育"APP进行查看</div>
      <p><span @click='close_applets'>取消</span>
        <span class="goapp">
          <a v-if="data" :href="'https://www.eoffcn.com/zg_jiaoyu/detail?orderSn=' + data.order_id + '&package_id=' + data.package_id + '&cid=' + data.cid + '&menu_id=' + data.menu_id
            + '&spuID=' + data.shopid + '&owner=' + owner + '&channel=' + channel + '&orgn=' + orgn + '&channelId=225'">去APP查看
          </a>
          <a v-else :href="'https://www.eoffcn.com/zg_jiaoyu/detail?channelId=225'">去APP查看
          </a>
        </span>
      </p>
    </div>
    <div class="open_applets_box" v-if="type==2">
      <div class="open_applets">
        <p class="tip_qrcode">小程序中暂不支持查看该课件，你可下载“中公教育”APP进行查看</p>
        <img class="qrcode_img" src="../../../static/images/qrcode_offcn.png">
        <input id="copytext" type="text" value="https://www.eoffcn.com/zg_jiaoyu/detail">
        <p class="copy_name" @click="copy_applets">复制下载链接</p>
        <p class="save_qrcode">长按保存二维码，扫码下载APP或使用浏览器打开下载链接</p>
      </div>
      <img @click="close_applets" src="../../../static/images/shut.png">
    </div>
  </div>
</template>
<script>
  import {Toast} from 'vant'

  export default {
    data () {
      return {
        owner: this.$route.query.owner,
        channel: this.$route.query.channel,
        orgn: this.$route.query.orgn
      }
    },
    methods: {
      close_applets () {
        this.$emit('isopen', 'false')
      },
      copy_applets () {
        var copytext = document.getElementById('copytext')
        console.log(copytext.select()) // 选择对象
        document.execCommand('Copy') // 执行浏览器复制命令
        Toast('下载链接复制成功')
      },
    },
    props: ['data', 'type'],
    mounted () {

    }
  }
</script>
<style lang="less" scoped>
  .popup-package {
    position: fixed;
    width: 100%;
    min-height: 100%;
    background: rgba(0, 0, 0, 0.6);
    .dialog_box {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 490px;
      line-height: 40px;
      border-radius: 18px;
      transform: translate(-50%, -50%);
      background: #fff;
      .dialog_message {
        text-align: center;
        padding: 30px 30px;
      }
      p {
        display: flex;
        border-top: 1px solid #e5e5e5;
        height: 70px;
        line-height: 70px;
        span {
          flex: 1;
          text-align: center;
        }
        .goapp {
          border-left: 1px solid #e5e5e5;
          a {
            color: #e60012;
          }
        }
      }
    }
    .open_applets_box {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 500px;
      transform: translate(-50%, -50%);
      text-align: center;
      .open_applets {
        padding: 50px 0;
        color: #666666;
        background: #ffffff;
        border-radius: 20px;
        .qrcode_img {
          width: 400px;
          height: 400px;
        }
        .tip_qrcode {
          font-size: 22px;
          margin: 0 86px 10px;
        }
        .save_qrcode {
          font-size: 22px;
          margin: 10px 86px 0;
        }
        .copy_name {
          width: 400px;
          line-height: 60px;
          font-size: 26px;
          color: #ffffff;
          background: #e60012;
          border-radius: 10px;
          margin: 0 auto;
        }
      }
      img {
        width: 100px;
        height: 100px;
      }
    }
    #copytext {
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/index.vue